// extracted by mini-css-extract-plugin
export var discard = "_2d-4";
export var muiTooltipTooltip = "_2d-6";
export var notificationBar = "_2d-3";
export var notificationContainer = "_2d-2";
export var saveButtonHoverSlotWrapper = "_2d-5";
export var show = "_2d-1";
export var spacer = "_2d-0";